import { writable } from 'svelte/store'

const store = () => {
    // console.log ('*: userStore -> store()')

    const state = {
        token_id: "",
        role: "0",
        name: "",
        username: "",
        disabled: "0",
        bean: null,
        sector: null,
        clientsWhitelist: [],
        activeFeatures: [],
        sectorsList: [],
    }

    const { subscribe, set, update } = writable(state)

    const methods = {
        init() {
            // console.log ('*: userStore => init')
        },

        setUser(config) {
            // console.log ('store => setUser', config)
            update(state => {
                state.token_id = config.token_id;
                state.role = config.role;
                state.name = config.name;
                state.username = config.username;
                state.disabled = state.disabled;
                state.bean = config;
                state.clientsWhitelist = config.clients_whitelist ? config.clients_whitelist.split(',') : [];
                state.activeFeatures = config.active_features ? config.active_features.split(',') : [];
                state.sectorsList = config.sectors ? config.sectors.split(',') : [];

                return state
            })
        },

        setUsername(username) {
            console.log('*: userStore => setUsername')
            update(state => {
                state.username = username
                return state
            })
        },

        setName(name) {
            console.log('*: userStore => setName')
            update(state => {
                state.name = name
                return state
            })
        },

        setSector(sector) {
            update(state => {
                state.sector = sector
                return state
            })
        }
    }

    return {
        subscribe,
        set,
        update,
        ...methods
    }
}

export default store()